import AppVersionInfoService from "./AppVersionInfoService";
import AppVersionInfoApiRouteService from "./AppVersionInfoApiRouteService";

class EmbeddedAppVersionInfoService extends AppVersionInfoService {
    constructor(apiClient) {
        super(apiClient, new AppVersionInfoApiRouteService("embedded-app-version"));
    }
}

export default EmbeddedAppVersionInfoService;
